var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.9466 2.70801H5.94661C3.09661 2.70801 1.98828 3.81634 1.98828 6.66634V13.333C1.98828 15.2497 3.02995 17.2913 5.94661 17.2913H10.9466C13.7966 17.2913 14.9049 16.183 14.9049 13.333V6.66634C14.9049 3.81634 13.7966 2.70801 10.9466 2.70801Z",
    fill: "#234CE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69655 9.48294C10.5618 9.48294 11.2632 8.78152 11.2632 7.91628C11.2632 7.05103 10.5618 6.34961 9.69655 6.34961C8.8313 6.34961 8.12988 7.05103 8.12988 7.91628C8.12988 8.78152 8.8313 9.48294 9.69655 9.48294Z",
    fill: "#234CE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1549 5.14168C17.8132 4.96668 17.0965 4.76668 16.1215 5.45001L14.8882 6.31668C14.8965 6.43334 14.9049 6.54168 14.9049 6.66668V13.3333C14.9049 13.4583 14.8882 13.5667 14.8882 13.6833L16.1215 14.55C16.6382 14.9167 17.0882 15.0333 17.4465 15.0333C17.7549 15.0333 17.9965 14.95 18.1549 14.8667C18.4965 14.6917 19.0715 14.2167 19.0715 13.025V6.98334C19.0715 5.79168 18.4965 5.31668 18.1549 5.14168Z",
    fill: "#234CE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon01);
export default __webpack_public_path__ + "static/media/chat-icon-01.33cfe902eeb8d1bf0c70bf00e8c2075d.svg";
export { ForwardRef as ReactComponent };